import LinkIcon from "@mixitone/icons/link.svg";
import { useLocation } from "react-router-dom";
import type { Path } from "router";
import { RoutedLink } from "./Link";

export type DrawerContextKey =
  | "groups"
  | "members"
  | "sessions"
  | "tournament"
  | "tournamentPlayers"
  | "tournamentEntries"
  | "tournamentMatches"
  | "tournamentGames"
  | "sessionPlayers";

const CONTEXT_CONFIG: Record<DrawerContextKey, { label: string; to: Path }> = {
  groups: { label: "Groups", to: "/clubs/:clubId/groups" },
  members: { label: "Members", to: "/clubs/:clubId/players" },
  sessions: { label: "Sessions", to: "/clubs/:clubId/sessions" },
  tournament: { label: "Tournament", to: "/tournament/:id" },
  tournamentPlayers: { label: "Players", to: "/tournament/:id/people/players" },
  tournamentEntries: { label: "Entries", to: "/tournament/:id/people/entries" },
  tournamentMatches: { label: "Matches", to: "/tournament/:id/matches" },
  tournamentGames: { label: "Games", to: "/tournament/:id/games" },
  sessionPlayers: { label: "Players", to: "/t/:token/players" },
};

type DrawerContextLinkProps = {
  context: DrawerContextKey;
  params: Record<string, string>;
};

const DrawerContextLink = ({ context, params }: DrawerContextLinkProps) => {
  const location = useLocation();
  const config = CONTEXT_CONFIG[context];

  return (
    <RoutedLink
      kind="link"
      to={config.to}
      // @ts-expect-error params are validated by callers for each context route
      params={params}
      state={location.state}
      className="inline-flex items-center gap-1 text-sm font-normal"
    >
      <LinkIcon className="h-4 w-4 stroke-current" />
      {config.label}
    </RoutedLink>
  );
};

export { DrawerContextLink };
